import {
  API_DATA_SUCCESS,
  API_DATA_FAILURE,
  API_DATA_LOADING,
  API_SUBMISSION_SUCCESS,
  API_SUBMISSION_LOADING,
  API_SUBMISSION_FAILURE,
  API_VALIDATEPAYMENT_SUCCESS,
  API_VALIDATEPAYMENT_LOADING,
  API_VALIDATEPAYMENT_FAILURE,
  LAST_BLURRED_FIELD,
  REMOVE_NOTIFICATION,
  API_MAKEPAYMENT_FAILURE,
  API_MAKEPAYMENT_LOADING,
  API_MAKEPAYMENT_SUCCESS,
  API_RECORDPAYMENT_FAILURE,
  API_RECORDPAYMENT_LOADING,
  API_RECORDPAYMENT_SUCCESS
} from "./constants";

import api from "../api";

export function apiDataFailure(bool, data) {
  return {
    type: API_DATA_FAILURE,
    hasFailed: bool,
    data
  };
}

export function apiDataIsLoading(bool) {
  return {
    type: API_DATA_LOADING,
    isLoading: bool
  };
}

export const apiDataSuccess = data => ({
  type: API_DATA_SUCCESS,
  data
});

export const fetchBasketData = id => dispatch => {
  dispatch(apiDataIsLoading(true));
  return api.basket
    .fetchData(id, true)
    .then(response => {
      if (response.status_code === 404) {
        dispatch(apiDataIsLoading(false));
        throw response;
      }
      if (!response) {
        dispatch(apiDataIsLoading(false));
        throw response;
      }
      dispatch(apiDataIsLoading(false));
      return response;
    })
    .then(response => dispatch(apiDataSuccess(response)))
    .catch(response => {
      return dispatch(apiDataFailure(true, response));
    });
};

export function apiSubmissionFailure(bool, data) {
  return {
    type: API_SUBMISSION_FAILURE,
    hasFailed: bool,
    data
  };
}

export function apiSubmissionIsLoading(bool) {
  return {
    type: API_SUBMISSION_LOADING,
    isLoading: bool
  };
}

export const apiSubmissionSuccess = data => ({
  type: API_SUBMISSION_SUCCESS,
  data
});

export function apiValidatePaymentFailure(bool, data) {
  return {
    type: API_VALIDATEPAYMENT_FAILURE,
    hasFailed: bool,
    data
  };
}

export function apiValidatePaymentIsLoading(bool) {
  return {
    type: API_VALIDATEPAYMENT_LOADING,
    isLoading: bool
  };
}

export const apiValidatePaymentSuccess = data => {
  return {
    type: API_VALIDATEPAYMENT_SUCCESS,
    data
  };
};

export const lastBlurredField = field => {
  return {
    type: LAST_BLURRED_FIELD,
    field
  };
};

export function apiMakePaymentFailure(bool, data) {
  return {
    type: API_MAKEPAYMENT_FAILURE,
    hasFailed: bool,
    data
  };
}

export function apiMakePaymentIsLoading(bool) {
  return {
    type: API_MAKEPAYMENT_LOADING,
    isLoading: bool
  };
}

export const apiMakePaymentSuccess = () => {
  return {
    type: API_MAKEPAYMENT_SUCCESS
  };
};

export function apiRecordPaymentFailure(bool, data) {
  return {
    type: API_RECORDPAYMENT_FAILURE,
    hasFailed: bool,
    data
  };
}

export function apiRecordPaymentIsLoading(bool) {
  return {
    type: API_RECORDPAYMENT_LOADING,
    isLoading: bool
  };
}

export const apiRecordPaymentSuccess = () => {
  return {
    type: API_RECORDPAYMENT_SUCCESS
  };
};

export const postBasketData = (
  id,
  transferId,
  data,
  final = false,
  local = false,
  extra = null
) => dispatch => {
  const transfers = {
    basket: {
      id,
      transfers: [
        {
          id: transferId,
          ...data
        }
      ]
    }
  };
  dispatch(apiSubmissionIsLoading(true));
  return api.basket
    .postData(transfers, final, extra, local)
    .then(response => {
      if (
        response.result === "error" ||
        response.status_description === "Not Found"
      ) {
        dispatch(apiSubmissionIsLoading(false));
        throw Error(response.message);
      }
      if (
        response.status_code === 400 &&
        response.status_description === "Bad Request"
      ) {
        dispatch(apiSubmissionIsLoading(false));
        throw response;
      }
      dispatch(apiSubmissionIsLoading(false));
      return response;
    })
    .then(response => {
      dispatch(apiSubmissionSuccess(response));
      return dispatch(apiDataSuccess(response));
    })
    .catch(res => dispatch(apiSubmissionFailure(true, res)));
};

export const changeBasketCurrency = (id, currency) => dispatch => {
  dispatch(apiDataIsLoading(true));
  const data = { basket: { id: id, currency: { code: currency } } };
  return api.basket
    .postData(data, true, "currency")
    .then(response => {
      if (response.result === "error") {
        dispatch(apiDataIsLoading(false));
        throw Error(response.message);
      }
      dispatch(apiDataIsLoading(false));
      return response;
    })
    .then(response => dispatch(apiDataSuccess(response)))
    .catch(() => dispatch(apiDataFailure(true)));
};

export const updateNotification = (id, item, text) => dispatch => {
  dispatch(apiDataIsLoading(true));

  const data = { basket: { id, [item]: text } };
  return api.basket
    .postData(data, true)
    .then(response => {
      if (response.result === "error") {
        dispatch(apiDataIsLoading(false));
        throw Error(response.message);
      }
      dispatch(apiDataIsLoading(false));
      return response;
    })
    .then(response => dispatch(apiDataSuccess(response)))
    .catch(() => dispatch(apiDataFailure(true)));
};

export const confirmBooking = (id, values) => dispatch => {
  dispatch(apiDataIsLoading(true));

  const data = { basket: { id, ...values } };
  return api.basket
    .postData(data, true)
    .then(response => {
      if (response.result === "error") {
        dispatch(apiDataIsLoading(false));
        throw Error(response.message);
      }
      dispatch(apiDataIsLoading(false));
      return response;
    })
    .then(response => dispatch(apiDataSuccess(response)))
    .catch(() => dispatch(apiDataFailure(true)));
};

export const changePoints = id => dispatch => {
  dispatch(apiDataIsLoading(true));
  return api.basket
    .changePoints(id)
    .then(response => {
      if (response.result === "error") {
        dispatch(apiDataIsLoading(false));
        throw Error(response.message);
      }
      dispatch(apiDataIsLoading(false));
      return response;
    })
    .then(response => dispatch(apiDataSuccess(response)))
    .catch(() => dispatch(apiDataFailure(true)));
};

export const proceedStep = (id, step) => dispatch => {
  dispatch(apiDataIsLoading(true));
  return api.basket
    .proceedStep(id, step)
    .then(response => {
      if (response.result === "error") {
        //|| response.status_code === 400
        dispatch(apiDataIsLoading(false));
        throw response.basket;
      }
      dispatch(apiDataIsLoading(false));
      return response;
    })
    .then(response => dispatch(apiDataSuccess(response)))
    .catch(response => dispatch(apiDataFailure(true, response)));
};

export function removeNotification() {
  return {
    type: REMOVE_NOTIFICATION
  };
}

export const validatePayment = (id, data) => dispatch => {
  const payments = {
    basket: {
      id
    },
    payment: {
      ...data
    }
  };
  dispatch(apiValidatePaymentIsLoading(true));
  return api.basket
    .validatePayment(payments)
    .then(response => {
      if (
        response.result === "error" ||
        response.status_description === "Not Found"
      ) {
        dispatch(apiValidatePaymentIsLoading(false));
        throw Error(response.message);
      }
      if (
        response.status_code === 400 &&
        response.status_description === "Bad Request"
      ) {
        dispatch(apiValidatePaymentIsLoading(false));
        throw response.error_messages;
      }
      dispatch(apiValidatePaymentIsLoading(false));
      return response;
    })
    .then(response => dispatch(apiValidatePaymentSuccess(response)))
    .catch(res => dispatch(apiValidatePaymentFailure(true, res)));
};

export const makePayment = (id, data, totalToPay) => dispatch => {
  const payments = {
    basket: {
      id
    },
    payment: {
      // ...data,
      // amount: totalToPay,
      // zip: data.postcode,
      // expDateMonth: data.validMonths,
      // expDateYear: data.validYears
      country: data.country,
      firstName: data.firstName,
      lastName: data.lastName,
      address1: data.address1,
      address2: data.address2,
      city: data.city,
      creditCardType: data.creditCardType,
      creditCardNumber: data.creditCardNumber,
      cvv2Number: data.cvv2Number,
      nameOnCard: data.nameOnCard,
      amount: totalToPay,
      zip: data.postcode,
      expDateMonth: data.validMonths,
      expDateYear: data.validYears
    }
  };

  dispatch(apiMakePaymentIsLoading(true));
  return api.basket
    .makePayment(payments)
    .then(response => {
      if (
        response.result === "error" ||
        response.status_description === "Not Found"
      ) {
        dispatch(apiMakePaymentIsLoading(false));
        throw Error(response.message);
      }
      if (response.status_code >= 400) {
        dispatch(apiMakePaymentIsLoading(false));
        throw response.basket.continueText.message;
      }
      dispatch(apiMakePaymentIsLoading(false));
      return response;
    })
    .then(response => {
      dispatch(apiMakePaymentSuccess());
      dispatch(apiDataSuccess(response));
      return response;
    })
    .catch(res => dispatch(apiMakePaymentFailure(true, res)));
};

export const recordPayment = (id, data) => dispatch => {
  const payments = {
    basket: {
      id
    },
    payment: {
      ...data
    }
  };
  dispatch(apiRecordPaymentIsLoading(true));
  return api.basket
    .recordPayment(payments)
    .then(response => {
      if (
        response.result === "error" ||
        response.status_description === "Not Found"
      ) {
        dispatch(apiRecordPaymentIsLoading(false));
        throw Error(response.message);
      }
      if (!data["result"]) {
        throw data["error"];
      }
      if (response.status_code >= 400) {
        dispatch(apiRecordPaymentIsLoading(false));
        throw response.error_messages;
      }
      dispatch(apiRecordPaymentIsLoading(false));
      return response;
    })
    .then(response => {
      dispatch(apiRecordPaymentSuccess());
      dispatch(apiDataSuccess(response));
      return response;
    })
    .catch(res => dispatch(apiRecordPaymentFailure(true, res)));
};



// WEBPACK FOOTER //
// ./src/actions/basket.js